/**
 * Standalone, Keycloak-free verify-email app bootstrap.
 *
 * Runs in main.tsx BEFORE — and INSTEAD OF — the normal app bootstrap when the
 * current path is /verify. Same pattern as signup-standalone: the path check
 * happens before initKeycloak() so the Keycloak login-required flow never
 * triggers for this public one-time-link page.
 *
 * Does NOT use TanStack Router — the verify page is pre-router, mounted as a
 * standalone React root. Consistent with signup-standalone and oauth-callback-
 * standalone (ADR-001 deliberate short-circuit for public paths).
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { VerifyApp } from './VerifyApp';

export const VERIFY_PATH = '/verify';

export function runVerifyApp(): void {
  const root = document.getElementById('root');
  if (!root) return;
  createRoot(root).render(
    <StrictMode>
      <VerifyApp />
    </StrictMode>,
  );
}
